import { get, post, put, Delete } from '@/plugins/axios.js'
// post
export const post_community_login = setting => post('community/login', setting) // 登录

export const post_community_edituserinfo = setting => post('community/edituserinfo', setting) // 编辑个人信息

export const post_community_upload = setting => post('community/upload', setting) // 文件上传

export const post_community_userinfo = setting => post('community/userinfo', setting) // 用户信息

export const post_community_posttops = setting => post('community/posttops', setting) // 置顶的帖子列表

export const post_community_posts = setting => post('community/posts', setting) // 帖子列表

export const post_community_addpost = setting => post('community/addpost', setting) // 发布帖子

export const post_community_userhome = setting => post('community/userhome', setting) // 社交主页

export const post_community_userfollow = setting => post('community/userfollow', setting) // 关注/取关用户

export const post_community_postthumb = setting => post('community/postthumb', setting) // 点赞(帖子)

export const post_community_commentthumb = setting => post('community/commentthumb', setting) // 点赞(评论)

export const post_community_userposts = setting => post('community/userposts', setting) // 用户帖子列表

export const post_community_postdetail = setting => post('community/postdetail', setting) // 帖子详情

export const post_community_postcomments = setting => post('community/postcomments', setting) // 帖子评论列表

export const post_community_replycomments = setting => post('community/replycomments', setting) // 回复评论列表

export const post_community_addcomment = setting => post('community/addcomment', setting) // 发布评论

export const post_community_replycomment = setting => post('community/replycomment', setting) // 回复评论

export const post_community_userfocus = setting => post('community/userfocus', setting) // 关注列表

export const post_community_userfollows = setting => post('community/userfollows', setting) // 粉丝列表

export const post_community_searchuser = setting => post('community/searchuser', setting) // 搜索用户列表

export const post_community_toppost = setting => post('community/toppost', setting) // 帖子置顶

export const post_community_canceltoppost = setting => post('community/canceltoppost', setting) // 取消帖子置顶

export const post_community_delpost = setting => post('community/delpost', setting) // 删除帖子

export const post_community_postnotinterest = setting => post('community/postnotinterest', setting) // 不感兴趣

export const post_community_dislikeuser = setting => post('community/dislikeuser', setting) // 不喜欢该用户

export const post_community_postreport = setting => post('community/postreport', setting) // 举报 (帖子)

export const post_community_postread = setting => post('community/postread', setting) // 浏览帖子

export const post_community_postsubjectrecommends = setting => post('community/postsubjectrecommends', setting) // 主题推荐帖子列表

export const post_community_delcomment = setting => post('community/delcomment', setting) // 删除评论

export const post_community_userpoststopn = setting => post('community/userpoststopn', setting) // 用户帖子主页概览(top n)

export const post_community_mymessages = setting => post('community/mymessages', setting) // 消息列表

// export const getCart = (id, currency) => get(`cart/${id}/${currency}`) // 用户购物车列表

// export const Getfivetime = () => get(`getfivetime`) // 获取黑五活动时间
// post
